/**
 * Created by YJZX-LCH on 2017-04-12.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import userInfo from './modules/users';
import passValue from './modules/passValue';
import pictureView from './modules/pictureview';
import teacherschools from './modules/teacherschools';
import photos from './modules/photos.js';
import SelectSignature from './modules/SelectSignature';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    userInfo,
    passValue,
    pictureView,
    teacherschools,
    SelectSignature,
    photos
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js